const TWO_MINUTES = 1000 * 60 * 2;
const THIRTY_MINUTES = 1000 * 60 * 30;
const ONE_DAY = 1000 * 60 * 60 * 24;
const SIX_MONTHS = ONE_DAY * 30 * 6; // this is an approximation

const times = {
  TWO_MINUTES,
  THIRTY_MINUTES,
  ONE_DAY,
  SIX_MONTHS
};
export default times;